import { jsx as _jsx } from "react/jsx-runtime";
import './Loader.scss';
var Loader = function (_a) {
    var width = _a.width, height = _a.height;
    return (_jsx("span", { style: { width: width, height: height }, className: "Loader" }));
};
export default Loader;
